import React from 'react'

function ProjectItem({ link, img, title }) {
  return (
    <div className="border-2 border-zinc-400 hover:border-[#ffd700] hover:bg-[#ffd700] rounded-lg w-fit flex justify-start h-[130px] box-border gap-5 p-4 text-[#ffd700]  hover:text-[#022c43] transition-all duration-500 ease-in">
      <img src={img} alt="" width={280} className="object-cover" />
      <div>
        <h1 className="text-4xl extrabold">{title}</h1>
        <a
          className=" hover:underline text-xl"
          target="_blank"
          rel="noreferrer"
          href={link}
        >
          Take a look
        </a>
      </div>
    </div>
  )
}

export default ProjectItem
